import { render } from "./BranchView.vue?vue&type=template&id=6d8929ad"
import script from "./BranchView.vue?vue&type=script&lang=js"
export * from "./BranchView.vue?vue&type=script&lang=js"

import "./BranchView.vue?vue&type=style&index=0&id=6d8929ad&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__